import { render, staticRenderFns } from "./AboutEvent.vue?vue&type=template&id=4ae4b80a&"
import script from "./AboutEvent.vue?vue&type=script&lang=js&"
export * from "./AboutEvent.vue?vue&type=script&lang=js&"
import style0 from "./AboutEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports